import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { numberOfRecipientsSelector } from '../../state/selectors';

import Breadcrumbs from 'shared/app/components/breadcrumbs';
import messages from '../../messages';

const GiftBreadcrumbs = () => {
  const numberOfRecipients = useSelector(numberOfRecipientsSelector);
  const breadcrumbTrail = [
    {
      text: <FormattedMessage {...messages.giftCardBreadcrumb} />,
      link: '/gift',
    },
    {
      text: (
        <FormattedMessage
          {...messages.createEGift}
          values={{ numberOfRecipients }}
        />
      ),
    },
  ];

  return (
    <Breadcrumbs
      TagName="nav"
      breadcrumbs={breadcrumbTrail}
      className="color-textBlackSoft"
    />
  );
};

export default GiftBreadcrumbs;
